import request from "../utils/request";

//面试列表
export function interviewList(params) {
    return request({
        url: '/api/interview/list',
        method: 'get',
        params
    })
}
//  创建面试信息
export function interviewCreate(data) {
    return request({
        url: '/api/interview/create',
        method: 'post',
        data
    })
}

// 更新面试信息

export function interviewUpdate(id, data) {
    return request({
        url: '/api/interview/' + id + '/update',
        method: 'post',
        data
    })
}

//查询面试详情
export function interviewInfo(id) {
    return request({
        url: '/api/interview/' + id,
        method: 'get'
    })
}


// 快答

export function quickAnswer(id,data) {
    return request({
        url: '/api/interview/' + id + '/ask',
        method: 'post',
        data
    })
}

// 实时转语音扣费 http://localhost:8080/api/interview/{interviewId}/stt/record-usage
export function recordUsage(id, data) {
    return request({
        url: '/api/interview/' + id + '/stt/record-usage',
        method: 'post',
        data
    })
}

// 结束面试

export function interviewEnd(id, data) {
    return request({
        url: '/api/interview/' + id + '/end',
        method: 'post',
        data
    })
}
// 支付(未使用)
export function pay(data) {
    return request({
        url: '/api/pay/ali/pcPay',
        method: 'post',
        data
    })
}
// 充值、消费记录
export function rechargeList(data) {
    return request({
        url: '/api/account/log/query ',
        method: 'post',
        data
       
    })
}

// 提现
export function transfer(data) {
    return request({
        url: '/api/pay/ali/transfer',
        method: 'post',
        data
    })
}

